import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import * as yup from "yup";
//import axios from "axios";
import countries from "./countries";

const defaultFormState = {
  country: "Afghanistan",
  name: "",
  street: "",
  apt: "",
  city: "",
  zip: "",
};

const defaultErrorState = {
  country: "",
  name: "",
  street: "",
  apt: "",
  city: "",
  zip: "",
};

const schema = yup.object().shape({
  country: yup.string().required("Please pick your country."),
  name: yup.string().required("Please enter your name."),
  street: yup.string().required("Please enter your address."),
  apt: yup.string(),
  city: yup.string().required("Please enter your city."),
  zip: yup.string().required("Please enter your zip code."),
});

const CheckOut = () => {
  const [formState, setFormState] = useState(defaultFormState);
  const [errors, setErrors] = useState(defaultErrorState);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(
    () => {
      schema.isValid(formState).then((valid) => setIsDisabled(!valid));
    },
    [formState],
    schema
  );

  const validate = (e) => {
    e.persist();
    yup
      .reach(schema, e.target.name)
      .validate(e.target.value)
      .then((valid) => setErrors({ ...errors, [e.target.name]: "" }))
      .catch((err) => setErrors({ ...errors, [e.target.name]: err.errors[0] }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formState);
  };

  const handleChange = (e) => {
    e.persist();
    validate(e);
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  return (
    <Container>
      <h1>Enter An Address</h1>
      <form onSubmit={handleSubmit} className='formContainer'>
        <label>
          <select
            defaultValue='Afghanistan'
            name='country'
            onChange={handleChange}
            data-cy='country'
          >
            {countries.map((e, i) => {
              return (
                <option key={i} value={e.name}>
                  {e.name}
                </option>
              );
            })}
          </select>
        </label>

        <label>
          <input
            type='text'
            name='name'
            onChange={handleChange}
            data-cy='name'
            value={formState.name}
            placeholder='Full Name'
          />
          {errors.name.length > 0 && (
            <p style={{ color: "red" }}>{errors.name}</p>
          )}
        </label>
        <label>
          <input
            type='text'
            name='street'
            onChange={handleChange}
            data-cy='street'
            value={formState.street}
            placeholder='Street Address'
          />
          {errors.street.length > 0 && (
            <p style={{ color: "red" }}>{errors.street}</p>
          )}
        </label>
        <label>
          <input
            type='text'
            name='apt'
            onChange={handleChange}
            data-cy='apt'
            value={formState.apt}
            placeholder='Apt / Suite'
          />
          {errors.apt.length > 0 && (
            <p style={{ color: "red" }}>{errors.apt}</p>
          )}
        </label>
        <label>
          <input
            type='text'
            name='city'
            onChange={handleChange}
            data-cy='city'
            value={formState.city}
            placeholder='City'
          />
          {errors.city.length > 0 && (
            <p style={{ color: "red" }}>{errors.city}</p>
          )}
        </label>
        <label>
          <input
            type='text'
            name='zip'
            onChange={handleChange}
            data-cy='zip'
            value={formState.zip}
            placeholder='Zip Code'
          />
          {errors.zip.length > 0 && (
            <p style={{ color: "red" }}>{errors.zip}</p>
          )}
        </label>
        <div>
          <Link to='/cart'>
            <button type='submit' data-cy='goBack'>
              Return To Cart
            </button>
          </Link>
          <Link to='/dashboard'>
            <button type='submit' data-cy='update' disabled={isDisabled}>
              Place Order
            </button>
          </Link>
        </div>
      </form>
    </Container>
  );
};

export default CheckOut;

const Container = styled.div`
  width: 50rem;
  text-align: center;
  align-items: center;
  max-width: 100%;
  margin: auto;
  overflow: hidden;
  padding: 2rem;
  margin-bottom: 3rem;
  border: black 0.1rem solid;

  h1 {
    font-size: 3rem;
  }

  .formContainer {
    display: flex;
    flex-direction: column;
    align-items: center;

    button {
      width: 7rem;
      margin: 0.5rem;
    }
  }
`;
